(() => {
  const isPreview = document.body.dataset.designPreview === 'true';
  function selectProductMedia(gallery, target) {
    if (!gallery) return;
    const panels = [...gallery.querySelectorAll('[data-product-media]')];
    const selected = panels.find(panel => panel.dataset.productMedia === target) || panels[0];
    if (!selected) return;
    panels.forEach(panel => {
      const active = panel === selected;
      panel.hidden = !active;
      if (!active) panel.querySelectorAll('video').forEach(video => video.pause());
      if (!active) panel.querySelectorAll('iframe').forEach(frame => {
        if (frame.dataset.mediaPlaying) { frame.src = frame.src; delete frame.dataset.mediaPlaying; }
      });
      else panel.querySelectorAll('iframe').forEach(frame => { frame.dataset.mediaPlaying = 'true'; });
    });
    gallery.querySelectorAll('[data-gallery-target]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.galleryTarget === selected.dataset.productMedia));
    });
  }
  function initializeProductGalleries() {
    document.querySelectorAll('[data-product-gallery]:not([data-gallery-ready])').forEach(gallery => {
      selectProductMedia(gallery, gallery.querySelector('[data-media-selected]')?.dataset.productMedia);
      gallery.dataset.galleryReady = 'true';
      const controls = gallery.querySelector('[data-gallery-controls]');
      if (controls) controls.hidden = false;
    });
  }
  initializeProductGalleries();
  document.addEventListener('shopify:section:load', initializeProductGalleries);
  document.addEventListener('ab:preview:navigate', initializeProductGalleries);
  document.addEventListener('click', event => {
    const thumbnail = event.target.closest('[data-gallery-target]');
    if (thumbnail) selectProductMedia(thumbnail.closest('[data-product-gallery]'), thumbnail.dataset.galleryTarget);
  });
  function updateHeaderMenuSpace() {
    const header = document.querySelector('.fall-header');
    if (header) header.style.setProperty('--ab-header-bottom', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
  }
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!details.matches('.fall-header details') || !details.open) return;
    updateHeaderMenuSpace();
    document.querySelectorAll('.fall-header details[open]').forEach(other => {
      if (other !== details) other.open = false;
    });
  }, true);
  window.addEventListener('resize', updateHeaderMenuSpace);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.fall-header details[open]').forEach(details => {
      const restoreFocus = details.contains(document.activeElement);
      details.open = false;
      if (restoreFocus) details.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('focusout', event => {
    const details = event.target.closest('.fall-header details[open]');
    if (details && event.relatedTarget && !details.contains(event.relatedTarget)) details.open = false;
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.fall-header details[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
    if (event.target.closest('[data-dismiss-feedback]')) document.getElementById('CartFeedback').hidden = true;
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-variant-select]')) return;
    const option = event.target.selectedOptions[0], section = event.target.closest('[data-product-section]');
    section.querySelector('[data-product-price]').textContent = option.dataset.price;
    const compare = section.querySelector('[data-product-compare]');
    if (compare) {
      compare.hidden = !option.dataset.comparePrice;
      compare.querySelector('[data-compare-price]').textContent = option.dataset.comparePrice || '';
    }
    if (option.dataset.mediaId) selectProductMedia(section.querySelector('[data-product-gallery]'), option.dataset.mediaId);
    section.querySelector('[name="add"]').disabled = option.dataset.available !== 'true';
    section.querySelector('[data-add-label]').textContent = option.dataset.available === 'true' ? 'Add to bag' : 'Sold out';
    if (!isPreview) { const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url); }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (isPreview) {
      event.preventDefault();
      let status = form.querySelector('[role="status"]');
      if (!status) { status = document.createElement('p'); status.className = 'fall-form-status'; status.setAttribute('role', 'status'); form.append(status); }
      status.textContent = 'Design preview — no order or information has been submitted.';
      return;
    }
    if (!form.matches('[data-cart-add]')) return;
    event.preventDefault();
    const button = form.querySelector('[name="add"]'), error = form.querySelector('.ab-form-error');
    button.disabled = true; button.setAttribute('aria-busy','true'); if (error) error.hidden = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'This item could not be added. Please try again.');
      const feedback = document.getElementById('CartFeedback');
      feedback.querySelector('[data-cart-message]').textContent = `${data.product_title || data.title || 'Your treat'} added to your bag.`;
      feedback.hidden = false;
      try {
        const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
        if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count); }
      } catch (_) { /* The item was added; the bag page shows its current contents. */ }
    } catch (failure) {
      if (error) { error.hidden = false; error.textContent = failure.message || 'Please check your connection and try again.'; }
    } finally {
      button.removeAttribute('aria-busy');
      const option = form.querySelector('[data-variant-select]')?.selectedOptions[0];
      button.disabled = option ? option.dataset.available !== 'true' : false;
    }
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-share-url]'); if (!button) return;
    const url = button.dataset.shareUrl, title = button.dataset.shareTitle;
    const status = button.nextElementSibling; status.textContent = '';
    try {
      if (navigator.share) await navigator.share({title, url});
      else if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(url); status.textContent = 'Link copied.'; }
      else { const input = document.createElement('input'); input.value = url; input.readOnly = true; input.setAttribute('aria-label','Link to share'); status.append('Copy this link: ', input); input.focus(); input.select(); }
    } catch (error) { if (error.name !== 'AbortError') status.textContent = `Share this link: ${url}`; }
  });
})();
